<!-- ===================================
     LA JOYA PARK RESORT - APP PRINCIPAL
     =================================== -->

<!-- Loader -->
<app-loader [isVisible]="isLoading"></app-loader>

<!-- Video Modal -->
<app-video-modal [isOpen]="isVideoModalOpen" (closeModal)="closeVideoModal()"></app-video-modal>

<!-- Header -->
<app-header></app-header>

<!-- Contenido principal -->
<main class="main-content">
  <!-- Hero Section -->
  <section id="home" class="hero-section">
    <div class="container">
      <div class="hero-content">
        <!-- Lado izquierdo: Título principal -->
        <div class="hero-text">
          <h1>Descubre la maravilla en Arequipa</h1>
        </div>
        
        <!-- Lado derecho: Video y descripción -->
        <div class="hero-media">
          <div class="video-thumbnail">
            <img [src]="getImageUrl('images/resort/video_poster.webp')" alt="La Joya Park Resort" class="video-poster">
            <button class="play-button" (click)="openVideoModal()">
              <img [src]="getImageUrl('icons/ui/video_playH.png')" alt="Play" class="play-icon">
            </button>
          </div>
          <p class="hero-description">Un proyecto único que se convertirá en el parque acuático más grande de todo Latinoamérica.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Imagen Principal del Resort -->
  <section class="main-resort-image">
    <div class="container">
      <div class="resort-image-wrapper">
        <img [src]="getImageUrl('images/hero/waterL.webp')" alt="Decoración de agua izquierda" class="water-decoration left">
        <img [src]="getImageUrl('images/hero/main.webp')" alt="La Joya Park Resort - Vista Aérea Completa" class="resort-main-image">
        <img [src]="getImageUrl('images/hero/water.webp')" alt="Decoración de agua derecha" class="water-decoration right">
        <img [src]="getImageUrl('images/hero/Diversión.png')" alt="Diversión" class="diversion-overlay">
      </div>
    </div>
  </section>

  <!-- Sección ¿Por qué elegirnos? -->
  <app-why-choose-us></app-why-choose-us>

  <!-- Sección Proyecto en Arequipa -->
  <section id="proyecto">
    <app-project-info [isGalleryOpen]="isGalleryOpen" (toggleGallery)="toggleGallery()"></app-project-info>
  </section>

  <!-- Galería de Fotos -->
  <app-photo-gallery [isOpen]="isGalleryOpen"></app-photo-gallery>

  <!-- Mapa Interactivo -->
  <app-interactive-map></app-interactive-map>

  <!-- Beneficios Section -->
  <section id="beneficios">
    <app-benefits-cards></app-benefits-cards>
  </section>

  <!-- Contacto Section -->
  <section id="contacto" class="contact-section">
    <app-footer></app-footer>
  </section>
</main>

<!-- Botón flotante de WhatsApp -->
<app-whatsapp-float></app-whatsapp-float>
